module.exports = __webpack_public_path__ + "assets/img/team-full-btn-6d237b2d.png";